jQuery(document).ready(function() {
  $('#payment_fortnights-datatable').DataTable({
    "processing": true,
    "serverSide": true,
    "pageLength": 50,
    "order": [[1, "desc"],
              [0, "desc"]],
    "ajax": {
      "url": $('#payment_fortnights-datatable').data('source')
    },
    "language": {
      "info": "Viendo _START_ de _END_ de _TOTAL_ registros",
      "infoEmpty": "Viendo 0 a 0 de 0 registros",
      "search": "Buscar",
      "lengthMenu": "Ver _MENU_ registros",
      "paginate": {
        "first":      "Primera",
        "last":       "Última",
        "next":       "Siguiente",
        "previous":   "Anterior"
      }
    },
    "pagingType": "simple_numbers",
    "columns": [
      {"data": "fortnight"},
      {"data": "year"},
      {"data": "date_register"},
      {'data': 'type_register'}
    ]
  });
});
